import React, { Component } from 'react';
// import * as $ from 'jquery';
import axios from 'axios';
import { compose } from 'recompose';
import { Trans, translate } from 'react-i18next';
import { withRouter, Link, Redirect } from 'react-router-dom';
import Header from '../../../components/Header';
import GoBackButton from '../../../components/GoBackButton';

let cancelToken;

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class PaymentDomicilioContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            centers: [],
            email: "",
            name: "",
            lastname: "",
            phone: "",
            centro_id: this.props.match.params.domicilioid,
            duracion_id: 1,
            duracion_str: "3 Meses",
            precio: 300,
            redirectToPayment: false,
            error: null
        };
    }

    componentDidMount() {
        cancelToken = axios.CancelToken.source();
        // Verifica si el centro seleccionado existe
        this.getListCenter({ token_id: this.props.getTokenId() })
            .then((centers) => {
                this.setState({ centers });
                if (centers.length > 0) {
                    if (!centers
                        .map((center) => center.id)
                        .includes(this.state.centro_id)
                    ) {
                        alert("El centro seleccionado no esta disponible");
                        this.props.history.replace(`${URI_VENTA_EN_LINEA}/domicilio_comercial`);
                    }
                }
            }
            )
            .catch((error) => {
                this.setState({ error });
            });

    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
    }

    getListCenter = (params) => {
        return new Promise((resolve, reject) => {
            this.props.post(
                "/getListCenter",
                params,
                (response) => resolve(response),
                (error) => reject(error),
                cancelToken
            );
        })
    }

    handleEmailChange = (event) => {
        this.setState({ email: event.target.value });
    }

    handleNameChange = (event) => {
        this.setState({ name: event.target.value });
    }

    handleLastnameChange = (event) => {
        this.setState({ lastname: event.target.value });
    }

    handlePhoneChange = (event) => {
        this.setState({ phone: event.target.value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        console.log("submit");
        this.setState({ redirectToPayment: true });
    }

    handleError = () => {
        console.log(this.state.error)
        this.props.history.replace(`${URI_VENTA_EN_LINEA}/domicilio_comercial`);
    }

    render() {
        if (this.state.error) {
            return this.handleError();
        }
        if (this.state.redirectToPayment) {
            // Redirige a la ruta deseada
            return <Redirect to={{
                pathname: "payment/" + this.state.centro_id + "/" + this.state.duracion_id,
                state: {
                    email: this.state.email,
                    name: this.state.name,
                    lastname: this.state.lastname,
                    phone: this.state.phone,
                    duracion_id: this.state.duracion_id,
                    duracion_str: this.state.duracion_str,
                    precio: this.state.precio
                }
            }} />
        }
        const { t } = this.props;
        return (
            <form className="content-resvations" onSubmit={this.handleSubmit}>
                <Header>
                    <h2>
                        <Trans i18nKey='venta_linea.index.domicilio.title'>
                            0 <br /> 2
                        </Trans>
                    </h2>
                </Header>
                <div className="container-domiciolio">
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas" >
                        <div className="container-forms flex-horizontal">
                            <h2 className="page-header">
                                <Trans>venta_linea.payment.personal_info</Trans>
                            </h2>
                            <div className="form-group">
                                <div className="input-group input-lg-xl">
                                    <div className="form-group">
                                        <select
                                            disabled={true}
                                            className="form-control input-lg"
                                            id="city-select"
                                            value={this.state.centro_id}>
                                            {this.state.centers.map((city) =>
                                                (<option key={city.id} className="opcion-select" value={city.id}>{city.name}</option>)
                                            )}
                                        </select>
                                    </div>
                                </div>
                                <div className="input-group-btn input-group-btn-movil">
                                    <Link to={`${URI_VENTA_EN_LINEA}/domicilio_comercial`}>
                                        <span className="return-store">
                                            <Trans>venta_linea.payment.change_center</Trans>
                                        </span>
                                    </Link>
                                </div>
                                <br></br>
                                <div className="input-group-btn btn-group input-group-btn-movil">
                                    <div className="grid-3">
                                        <button type="button" onClick={() => this.setState({ duracion_id: 1, duracion_str: "3 Meses", precio: 300 })} className={this.state.duracion_id === 1 ? "btn btn_group_store btn_group_select" : "btn btn_group_store"}>
                                            <p>3 Meses</p>
                                            <p className="btn_store_text">$300.00 USD<br></br>+ IVA</p>
                                        </button>
                                        <button type="button" onClick={() => this.setState({ duracion_id: 2, duracion_str: "6 Meses", precio: 600 })} className={this.state.duracion_id === 2 ? "btn btn_group_store btn_group_select" : "btn btn_group_store"}>
                                            <p>6 Meses</p>
                                            <p className="btn_store_text">$600.00 USD<br></br>+ IVA</p>
                                        </button>
                                        <button type="button" onClick={() => this.setState({ duracion_id: 3, duracion_str: "12 Meses", precio: 1200 })} className={this.state.duracion_id === 3 ? "btn btn_group_store btn_group_select" : "btn btn_group_store"}>
                                            <p>12 Meses</p>
                                            <p className="btn_store_text">$1,200.0 USD<br></br>+ IVA</p>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas" >
                        <div className="panel-resvations container-forms">
                            <div className="forms">
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.handleEmailChange}
                                            placeholder={t('dashboard.room_payment.holder_email')}
                                            required
                                            type="email"
                                            value={this.state.email} />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.handleNameChange}
                                            placeholder={t('dashboard.room_payment.holder_name')}
                                            required
                                            type="text"
                                            value={this.state.name} />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.handleLastnameChange}
                                            placeholder={t('dashboard.room_payment.holder_lastname')}
                                            required
                                            type="text"
                                            value={this.state.lastname} />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.handlePhoneChange}
                                            placeholder={t('dashboard.room_payment.holder_phone')}
                                            required
                                            type="tel"
                                            pattern="[0-9]{10}"
                                            value={this.state.phone} />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <span className="return-store">
                                        * <Trans>venta_linea.payment.accept_contact</Trans>
                                    </span>
                                </div>
                                <section className="row">
                                    <GoBackButton
                                        isButtonForm
                                        isPayment
                                    />
                                    <button className="continua_button btn btn-primary col-md-6">
                                        <Trans>dashboard.room_payment.btn_continue</Trans>
                                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                    </button>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default compose(
    translate('common'),
    withRouter
)(PaymentDomicilioContainer);



// WEBPACK FOOTER //
// ./src/store/Domicilio/Payment/PaymentDomicilioContainer.js